<template>
    <div>
        <div
            class="card-fa-div"
            style="
                width: 99%;
                height: 890px;
                margin-top: 30px;
                margin-left: 5px;
                padding-top: 0px;
                float: left;
            "
        >
            <el-card
                class="box-card"
                style="height: 840px; width: 1680px; margin: 0 auto"
            >
                <div
                    style="
                        width: 100%;
                        line-height: 30px;
                        margin-top: 10px;
                        text-align: left;
                    "
                >
                    <div style="text-align: left">
                        <span
                            class="title-l3"
                            style="
                                font-size: 22px;
                                font-weight: 500;
                                font-size: 18px;
                                color: #262626;
                                margin-left: 30px;
                            "
                            >府级政区：</span
                        >
                        <el-button
                            :type="item == highLightFuItem ? 'primary' : 'text'"
                            v-for="(item, index) in fuData"
                            v-bind:key="index"
                            style="
                                text-align: left;
                                padding: 5px;
                                font-size: 16px;
                            "
                            @click="changeCountry(item)"
                        >
                            {{ item }}
                        </el-button>
                    </div>

                    <div style="text-align: left; margin-top: 10px">
                        <span
                            class="title-l4"
                            style="
                                font-size: 22px;
                                font-weight: 500;
                                font-size: 18px;
                                color: #262626;
                                margin-left: 30px;
                            "
                            >县级政区：</span
                        >
                        <el-button
                            :type="
                                item == highLightCounterItem
                                    ? 'primary'
                                    : 'text'
                            "
                            :class="
                                   isNoHaveSurvey(item)
                                        ? 'xianadjustgray'
                                        : ''
                                "
                            v-for="(item, index) in countryData"
                            v-bind:key="index"
                            style="
                                text-align: left;
                                padding: 5px;
                                font-size: 16px;
                            "
                            @click="changeCounty(item)"
                        >
                            {{ item }}
                        </el-button>
                       
                    </div>

                    <div
                        style="
                            width: 1620px;
                            height: 1px;
                            background: #e8e8e8;
                            margin-top: 30px;
                            margin-left: 30px;
                        "
                    ></div>
                    <div style="width: 1600px; margin-top: 30px">
                        <el-image
                            style="
                                height: 630px;
                                width: 1600px;
                                margin-left: 30px;
                            "
                            src="/static/img/data.png"
                            fit="fill"
                        >
                        </el-image>
                       
                    </div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            data: [],
            fuData: ["兰州府","平凉府","庆阳府","宁夏府","巩昌府","西宁府","凉州府","甘州府","肃州直隶州","泾州直隶州","固原州直隶州","化平川直隶厅","秦州直隶州","阶州直隶州","安西州直隶州"],
            highLightFuItem: '',
            countryData: [],
            highLightCounterItem: '',
            noHaveSurvey:["安化县",	"安化县董志原分县" ,"合水县" ,"宁州", "固原州" ,"固原州同心城分巡", "中卫县" ,"西和县", "岷州" ,"秦州" ,"河州太子寺分州", "徽县" ,"阶州" ,"阶州西固分州" ,"阶州白马关分州", "文县" ,"成县", "武威县" ,"镇番县" ,"平番县西大通分县" ,"张掖县东乐分县"]
        }
    },

    computed: {},

    mounted() {
        this.getCountry()
    },

    methods: {
        getCountry() {
            let temp = {}
            axios({
                url: $webConfig.V3.backendAPI+"getCountyNew",
                method: 'get',
                params: {
                    // service: 'WFS',
                    // version: '1.0.0',
                    // request: 'GetFeature',
                    // typeName: 'lwdgis:gs_county_region_1911',
                    // outputFormat: 'application/json',
                },
            }).then((res) => {
                           res.data.data.forEach((feature) => {
                    if(!(feature[0] in temp)){
                        temp[feature[0]] = [feature[1]]
                    }else{
                        temp[feature[0]].push(feature[1])
                    }
                })
                this.data = temp
                // res.data.features.forEach((feature) => {
                //     let item = feature.properties
                //     let key = item.二级政
                //     if (!(key in temp)) {
                //         temp[key] = []
                //     }
                //     temp[key].push(item.CHNAME)
                // })
                // this.data = temp

                // let fuDataTemp = []
                // for (let i in temp) {
                //     fuDataTemp.push(i)
                // }
                // this.fuData = fuDataTemp.sort(function (a, b) {
                //     return a.length - b.length
                // })
            })
        },

        changeCountry(value) {
            this.highLightFuItem = value
            this.countryData = this.data[value]
        },
        isNoHaveSurvey(value){
            if(this.noHaveSurvey.indexOf(value) > -1){
                return true
            }else{
                return false
            }
        },
        changeCounty(value) {
            this.highLightCounterItem = value
            if(this.isNoHaveSurvey(value)){
                this.$message({
                    message: "暂时没有此县调查表",
                    type: 'info',
                })
            }else{
            window.open('http://hgis.fudan.edu.cn/archives/6645', '_blank')

            }
        },

        gotolink() {
            window.open('http://hgis.fudan.edu.cn/archives/6645', '_blank')
        },
    },
}
</script>
<style scoped>
.xianadjustgray{
    color:gray !important
}
</style>



// WEBPACK FOOTER //
// src/V3/Main/comOriginData.vue